export const getPairingStyleColor = (style: string): string => {
  switch (style) {
    case 'complementary':
      return 'success';
    case 'contrast':
      return 'processing';
    case 'experimental':
      return 'purple';
    default:
      return 'default';
  }
};
